import AssignmentsCalendarContainer from './containers/AssignmentsCalendarContainer'

export default AssignmentsCalendarContainer
